<template>
  <div id="auth" class="container">
    <div class="row">
      <div class="col">
        <h1>Bem vindo a nossa integração de conta</h1>
      </div>
    </div>
    <div class="container" v-show="isValid()">
      <div class="row">
        <div class="col">
          <p v-show="auth_confirmation == null">
            Informe seu número abaixo para prosseguir
          </p>
          <p v-show="auth_confirmation != null">
            Confirme o código enviado por SMS
          </p>
        </div>
      </div>
      <div id="phone_auth" class="row justify-content-md-center">
        <div class="col-md-auto">
          <div class="input-group mb-3">
            <the-mask
              v-model="phone_auth"
              id="input_phone"
              :mask="['(##) #####-####']"
              class="form-control"
              type="tel"
              v-show="auth_confirmation == null"
            />
            <the-mask
              v-model="code_auth"
              id="input_code"
              :mask="['# # # # # #']"
              class="form-control"
              type="tel"
              v-show="auth_confirmation != null"
            />
            <div class="input-group-append">
              <button
                id="button_phone"
                class="btn btn-dark"
                type="button"
                :disabled="!validatePhone(phone_auth)"
                v-show="auth_confirmation == null"
              >
                Entrar
              </button>
              <button
                id="button_code"
                class="btn btn-dark"
                type="button"
                :disabled="!validateCode(code_auth)"
                v-on:click="sendCode"
                v-show="auth_confirmation != null"
              >
                Entrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container" v-show="!isValid()">
      <div class="row">
        <div class="col">
          <p>A página não tem as informações do solicitador</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { firebase, auth } from "../configs/firebase.js";
import { validatePhone, validateCode, validateURL } from "../static.js";

export default {
  name: "Auth",
  data() {
    return {
      phone_auth: "",
      code_auth: "",
      auth_confirmation: null,
    };
  },
  props: ["external", "public_key", "callback"],
  methods: {
    validatePhone,
    validateCode,
    validateURL,
    isValid() {
      if (
        this.public_key == null ||
        this.callback == null ||
        this.external == null ||
        this.external.length < 1
      )
        return false;
      let url = Buffer.from(this.callback, "base64").toString("utf-8");
      let test = this.validateURL(url);
      if (test) {
        this.$root.public_key = this.public_key;
        this.$root.external = this.external;
        this.$root.callback = url;
      }
      return test;
    },
    async sendSMS() {
      this.$root.loading = true;

      const invalidNumberError = "auth/invalid-phone-number";

      try {
        let phone = this.phone_auth;

        if (this.validatePhone(phone)) {
          let response = await auth.signInWithPhoneNumber(
            "+55" + phone,
            window.recaptchaVerifier
          );
          this.auth_confirmation = response;

          this.$root.loading = false;
        } else {
          throw Error(invalidNumberError);
        }
      } catch (e) {
        this.$root.loading = false;

        if (e.message == invalidNumberError || e.code == invalidNumberError) {
          alert("Número de telefone inválido");
        } else {
          alert("Erro ao validar seu número, tente novamente (" + e.code + ")");
        }
      }
    },
    async sendCode() {
      this.$root.loading = true;

      const invalidCodeError = "auth/invalid-verification-code";

      try {
        let code = this.code_auth;

        if (this.validateCode(code)) {
          await this.auth_confirmation.confirm(code);
        } else {
          throw Error(invalidCodeError);
        }
      } catch (e) {
        this.$root.loading = false;

        if (e.message == invalidCodeError || e.code == invalidCodeError) {
          alert("O código digitado é inválido, verifique o SMS");
        } else {
          alert("Erro ao obter código, tente novamente (" + e.code + ")");
        }
      }
    },
  },
  mounted() {
    if (this.isValid()) {
      window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
        "button_phone",
        {
          size: "invisible",
          callback: async () => {
            await this.sendSMS();
          },
        }
      );

      window.recaptchaVerifier.render().then((widgetId) => {
        window.recaptchaWidgetId = widgetId;
      });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
